import * as Sentry from '@sentry/react'

let initialized = false

export function initErrorTracking(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined

  if (!dsn) {
    console.info('[ErrorTracking] Sentry DSN not configured, using console logging')
    return
  }

  const isDev = import.meta.env.DEV

  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_APP_ENV as string | undefined) || (isDev ? 'development' : 'production'),
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: isDev ? 1.0 : 0.1,
  })

  initialized = true
  console.info('[ErrorTracking] Sentry initialized')
}

export function captureException(error: unknown, context?: Record<string, unknown>): void {
  if (initialized) {
    Sentry.withScope((scope) => {
      if (context) {
        scope.setExtras(context)
      }
      Sentry.captureException(error)
    })
  } else {
    console.error('[ErrorTracking]', error, context)
  }
}
